import { useEffect } from 'react';

import { useSelector } from 'src/state';
import { CONFIG } from 'src/global-config';
import { selectUser } from 'src/state/user/selectors';

import { useSettingsContext } from 'src/components/settings';

// ----------------------------------------------------------------------

declare global {
  interface Window {
    Featurebase: ((...args: unknown[]) => void) & { q?: unknown[] };
  }
}

function loadFeaturebaseSDK() {
  const scriptId = 'featurebase-sdk';
  if (document.getElementById(scriptId)) return;

  const script = document.createElement('script');
  script.id = scriptId;
  script.src = 'https://do.featurebase.app/js/sdk.js';
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode?.insertBefore(script, firstScript);
}

export const FEATUREBASE_DISABLED_KEY = 'featurebase_disabled';

export function FeaturebaseProvider() {
  const user = useSelector(selectUser);
  const settings = useSettingsContext();

  useEffect(() => {
    if (!user.id || !CONFIG.featurebase.appId || !user.featurebase_token) return;
    if (localStorage.getItem(FEATUREBASE_DISABLED_KEY) === 'true') return;

    if (typeof window.Featurebase !== 'function') {
      window.Featurebase = (...args: unknown[]) => {
        (window.Featurebase.q = window.Featurebase.q || []).push(args);
      };
    }

    loadFeaturebaseSDK();

    window.Featurebase('boot', {
      appId: CONFIG.featurebase.appId,
      featurebaseJwt: user.featurebase_token,
      theme: settings.state.mode,
      language: user.language || 'en',
    });
  }, [user.id, user.email, user.language, user.featurebase_token, settings.state.mode]);

  return null;
}
